module.exports = __webpack_public_path__ + "img/primerContacto.21d8359a.png";